import React from "react";
import background from "../../assets/ui/intro_optimizada.webp";
import securityDesktop from "../../assets/ui/Iconos-seguridad-desktop.svg";
import securityMobile from "../../assets/ui/Iconos-seguridad-mobile.svg";
import titleIcon from "../../assets/ui/mg-sz-hybrid+.svg";

interface IntroComponentProps {
  isPortrait: boolean;
  showIntro: boolean;
  ShowStudio: () => void;
  enableTouchScreen: () => void;
}

const IntroComponent: React.FC<IntroComponentProps> = ({ isPortrait, showIntro, ShowStudio, enableTouchScreen}) => {

  React.useEffect(() => {
    window.addEventListener('touchstart', enableTouchScreen)
    return () => {
      window.removeEventListener('touchstart', enableTouchScreen)
    };
  }, [enableTouchScreen]);

  return (
    <div className={`intro-container ${showIntro ? '':'hide-container'}`} style={{ backgroundImage: `url(${background})` }}>
      <div className={`intro-content ${isPortrait ? 'portrait':''}`}>
        <img className={`intro-top-title-icon ${isPortrait ? 'portrait':''}`} src={titleIcon} alt="" />
        {/* <div className={`intro-top ${isPortrait ? 'portrait':''}`}>
          <div className={`intro-top-title ${isPortrait ? 'portrait':''}`}>MG ZS</div>
          <div className={`intro-top-subtitle ${isPortrait ? 'portrait':''}`}>Hybrid+ 2025</div>
        </div> */}
        <div className={`intro-bottom ${isPortrait ? 'portrait':''}`}>
          <div className={`intro-bottom-line ${isPortrait ? 'portrait':''}`}/>
          <img className={`intro-bottom-security ${isPortrait ? 'portrait':''}`} src={isPortrait ? securityMobile : securityDesktop} alt="" />
          <div className={`intro-bottom-button ${isPortrait ? 'portrait':''}`} onClick={()=>{ShowStudio()}}>Vive la experiencia</div>
        </div>
      </div>
    </div>
  );
};

export default IntroComponent;